import { withSvgIcon } from './withSvgIcon';

export const NavBarPricing = withSvgIcon(
  <>
    <path
      d="M7 15.0505C5.76281 15.6818 5 16.5464 5 17.5C5 19.433 8.13401 21 12 21C15.866 21 19 19.433 19 17.5C19 16.5464 18.2372 15.6818 17 15.0505"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M7 10.0505C5.76281 10.6818 5 11.5464 5 12.5C5 14.433 8.13401 16 12 16C15.866 16 19 14.433 19 12.5C19 11.5464 18.2372 10.6818 17 10.0505"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <ellipse
      cx="12"
      cy="7.5"
      rx="7"
      ry="3.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
